export const UPDATE_MARKETING_CONSENT_PENDING = 'UPDATE_MARKETING_CONSENT_PENDING';
export const UPDATE_MARKETING_CONSENT_FULFILLED = 'UPDATE_MARKETING_CONSENT_FULFILLED';
export const UPDATE_MARKETING_CONSENT_REJECTED = 'UPDATE_MARKETING_CONSENT_REJECTED';
export const GET_MARKETING_CONSENTS_PENDING = 'GET_MARKETING_CONSENTS_PENDING';
export const GET_MARKETING_CONSENTS_FULFILLED = 'GET_MARKETING_CONSENTS_FULFILLED';
export const GET_MARKETING_CONSENTS_REJECTED = 'GET_MARKETING_CONSENTS_REJECTED';
export const GET_MARKETING_CONSENT_PENDING = 'GET_MARKETING_CONSENT_PENDING';
export const GET_MARKETING_CONSENT_FULFILLED = 'GET_MARKETING_CONSENT_FULFILLED';
export const GET_MARKETING_CONSENT_REJECTED = 'GET_MARKETING_CONSENT_REJECTED';

export default function marketingConsentsReducer(state = {
  marketingConsents: [],
  marketingConsent: '',
  fetching: false,
  fetched: true
}, action) {
  switch (action.type) {
    case GET_MARKETING_CONSENTS_PENDING: {
      return {
        ...state,
        fetching: true,
        fetched: false
      };
    }
    case GET_MARKETING_CONSENTS_FULFILLED: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        marketingConsents: action.payLoad.data
      };
    }
    case GET_MARKETING_CONSENTS_REJECTED:
    case UPDATE_MARKETING_CONSENT_PENDING:
    case UPDATE_MARKETING_CONSENT_FULFILLED:
    case UPDATE_MARKETING_CONSENT_REJECTED:
    case GET_MARKETING_CONSENT_PENDING: {
      return {
        ...state,
        fetching: true,
        fetched: false
      };
    }
    case GET_MARKETING_CONSENT_FULFILLED: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        marketingConsent: action.payLoad
      };
    }
    case GET_MARKETING_CONSENT_REJECTED:
    default: return {...state};
  }
}

